const TOKEN_SYMBOL_TO_ADDRESS = {
  USDC: "0x04068da6c83afcfa0e13ba15a6696662335d5b75",
  WFTM: "0x21be370d5312f44cb42ce377bc9b8a0cef1a4c83",
  TOMB: "0x6c021ae822bea943b2e66552bde1d2696a53fbb7",
};

const TOKEN_ADDRESS_TO_SYMBOL = Object.entries(TOKEN_SYMBOL_TO_ADDRESS).reduce((prev, curr) => ({
  ...prev,
  [curr[1]]: curr[0]
}), {});

const PREFERRED_SWAP_PATH_TOKEN_ADDRESS = TOKEN_SYMBOL_TO_ADDRESS.WFTM;
const WRAPPED_NATIVE_TOKEN = TOKEN_SYMBOL_TO_ADDRESS.WFTM;

const TOKEN_ADDRESS_TO_DECIMALS = {
  [TOKEN_SYMBOL_TO_ADDRESS.USDC]: 6,
  [TOKEN_SYMBOL_TO_ADDRESS.WFTM]: 18,
  [TOKEN_SYMBOL_TO_ADDRESS.TOMB]: 18,
};

module.exports = {
  TOKEN_ADDRESS_TO_DECIMALS,
  TOKEN_SYMBOL_TO_ADDRESS,
  TOKEN_ADDRESS_TO_SYMBOL,
  PREFERRED_SWAP_PATH_TOKEN_ADDRESS,
  WRAPPED_NATIVE_TOKEN,
};
